// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { EnumMapRule, EnumMapRuleT, verifyEnumMapRule } from "./enum-map-rule";
import { FlagRule, FlagRuleT, verifyFlagRule } from "./flag-rule";
import { IgnoreRule, IgnoreRuleT, verifyIgnoreRule } from "./ignore-rule";
import { RecordRule, RecordRuleT, verifyRecordRule } from "./record-rule";
import { Rule, unionToRule, unionListToRule } from "./rule";
import { TransformRule, TransformRuleT, verifyTransformRule } from "./transform-rule";
import { ValuedRule, ValuedRuleT, verifyValuedRule } from "./valued-rule";

/**
 * One field of a record and the rule it drives.
 */
export class FieldRule implements flatbuffers.IUnpackableObject<FieldRuleT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): FieldRule {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFieldRule(bb: flatbuffers.ByteBuffer, obj?: FieldRule): FieldRule {
    return (obj || new FieldRule()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsFieldRule(bb: flatbuffers.ByteBuffer, obj?: FieldRule): FieldRule {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new FieldRule()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  field(): string;
  field(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  field(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  ruleType(): Rule {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Rule.NONE;
  }

  rule<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  positionField(): string | null;
  positionField(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  positionField(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startFieldRule(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addField(builder: flatbuffers.Builder, fieldOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, fieldOffset, 0);
  }

  static addRuleType(builder: flatbuffers.Builder, ruleType: Rule) {
    builder.addFieldInt8(1, ruleType, Rule.NONE);
  }

  static addRule(builder: flatbuffers.Builder, ruleOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, ruleOffset, 0);
  }

  static addPositionField(builder: flatbuffers.Builder, positionFieldOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, positionFieldOffset, 0);
  }

  static endFieldRule(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // field
    builder.requiredField(offset, 8); // rule
    return offset;
  }

  static createFieldRule(
    builder: flatbuffers.Builder,
    fieldOffset: flatbuffers.Offset,
    ruleType: Rule,
    ruleOffset: flatbuffers.Offset,
    positionFieldOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    FieldRule.startFieldRule(builder);
    FieldRule.addField(builder, fieldOffset);
    FieldRule.addRuleType(builder, ruleType);
    FieldRule.addRule(builder, ruleOffset);
    FieldRule.addPositionField(builder, positionFieldOffset);
    return FieldRule.endFieldRule(builder);
  }

  unpack(): FieldRuleT {
    return new FieldRuleT(
      this.field(),
      this.ruleType(),
      (() => {
        const temp = unionToRule(this.ruleType(), this.rule.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
      this.positionField(),
    );
  }

  unpackTo(_o: FieldRuleT): void {
    _o.field = this.field();
    _o.ruleType = this.ruleType();
    _o.rule = (() => {
      const temp = unionToRule(this.ruleType(), this.rule.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
    _o.positionField = this.positionField();
  }

  unpackFields(...fields: string[]): FieldRuleT {
    const t = new FieldRuleT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("field")) {
      t.field = this.field();
    }
    if (fieldSet.has("rule_type")) {
      t.ruleType = this.ruleType();
    }
    if (fieldSet.has("rule")) {
      t.rule = (() => {
        const temp = unionToRule(this.ruleType(), this.rule.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    if (fieldSet.has("position_field")) {
      t.positionField = this.positionField();
    }
    return t;
  }
}

export class FieldRuleT implements flatbuffers.IGeneratedObject {
  constructor(
    public field: string | Uint8Array | null = null,
    public ruleType: Rule = Rule.NONE,
    public rule:
      | EnumMapRuleT
      | FlagRuleT
      | IgnoreRuleT
      | RecordRuleT
      | TransformRuleT
      | ValuedRuleT
      | null = null,
    public positionField: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.field === null || this.field === undefined) {
      throw new Error('Required field "field" is not set');
    }
    if (this.rule === null || this.rule === undefined) {
      throw new Error('Required field "rule" is not set');
    }
    const field = this.field !== null ? builder.createString(this.field!) : 0;
    const rule = builder.createObjectOffset(this.rule);
    const positionField =
      this.positionField !== null ? builder.createString(this.positionField!) : 0;

    return FieldRule.createFieldRule(builder, field, this.ruleType, rule, positionField);
  }

  clone(): FieldRuleT {
    const obj = new FieldRuleT();
    obj.field = this.field;
    obj.ruleType = this.ruleType;
    obj.rule =
      this.rule !== null && typeof (this.rule as any).clone === "function"
        ? (this.rule as any).clone()
        : this.rule;
    obj.positionField = this.positionField;
    return obj;
  }

  equals(other: FieldRuleT): boolean {
    if (this.field !== other.field) return false;
    if (this.ruleType !== other.ruleType) return false;
    if (this.rule !== null && other.rule !== null) {
      if (typeof (this.rule as any).equals === "function") {
        if (!(this.rule as any).equals(other.rule)) return false;
      } else if (this.rule !== other.rule) return false;
    } else if (this.rule !== other.rule) return false;
    if (this.positionField !== other.positionField) return false;
    return true;
  }
}

export function verifyFieldRule(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "field");
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkUnionConsistency(tablePos, 6, 8, "rule");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 6);
        switch (uType) {
          case 1: // IgnoreRule
            {
              const o = verifier.readInt32(pos);
              verifyIgnoreRule(verifier, pos + o);
            }
            break;
          case 2: // FlagRule
            {
              const o = verifier.readInt32(pos);
              verifyFlagRule(verifier, pos + o);
            }
            break;
          case 3: // ValuedRule
            {
              const o = verifier.readInt32(pos);
              verifyValuedRule(verifier, pos + o);
            }
            break;
          case 4: // EnumMapRule
            {
              const o = verifier.readInt32(pos);
              verifyEnumMapRule(verifier, pos + o);
            }
            break;
          case 5: // RecordRule
            {
              const o = verifier.readInt32(pos);
              verifyRecordRule(verifier, pos + o);
            }
            break;
          case 6: // TransformRule
            {
              const o = verifier.readInt32(pos);
              verifyTransformRule(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 8, "rule");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
